module.exports = __webpack_public_path__ + "assets/ta-icon-875745.svg";